import React, { memo, useContext, useEffect, useMemo, useState, useCallback } from 'react';
import { useStyles } from '../../../LawPortal.styles';
import {
  ButtonLink,
  MTable,
  Transition
} from '../../../../../Components';
import { useIntl } from 'react-intl';
import {
  Button,
  Grid,
  Tooltip,
} from '@material-ui/core';
import {
  ArchiveOutlined,
  ArrowRightAlt,
  Edit,
  UnarchiveOutlined,
} from '@material-ui/icons';
import { CreateDirectCompliance } from "./CreateDirectCompliance";
import { ModuleContext } from '../../../../../Context/ModuleContext/ModuleContext';
import {
  AccessLevel,
  LawPortalFeature,
  Module,
  UserContext
} from "../../../../../Context/UserContext/UserContext";
import { useAptorApi } from "../../../../../Api";
import PlanningViewLK from "./View/PlanningViewLK";
import moment from "moment";
import { useComplianceState } from "./List/ComplianceState";
import { ExecuteFilter } from "./ExecuteFilter";
import { useFilter } from "../../../../../Components/ListFilter";
import { useNavigate, useLocation } from "react-router-dom";
import { MTableToolbar } from '@material-table/core';
import { useSnackbar } from 'notistack';
import { useConfirmation } from '../../../../../Context/ConfirmationContext/ConfirmationContext';
import { filter } from 'lodash';

// Memoized IconsNode component
const IconsNode = memo(({ planData, activeTab, onArchive, onUnarchive, onComplianceSession, formatMessage }: any) => {
  return (
    <>
      {activeTab === 'complete' ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '7px' }}>
          <Tooltip title={formatMessage({ id: "law-portal.unarchive" })}>
            <div onClick={() => onUnarchive(planData)}>
              <UnarchiveOutlined style={{ cursor: 'pointer' }} />
            </div>
          </Tooltip>
        </div>
      ) : (
        <Grid style={{ display: 'flex', gap: '10px' }} item>
          <Tooltip title={formatMessage({ id: "law-portal.archive" })}>
            <div onClick={() => onArchive(planData)}>
              <ArchiveOutlined style={{ cursor: 'pointer' }} />
            </div>
          </Tooltip>
          {planData?.lawCount > 0 && planData.isExecutionVisible && (
            <Button 
              variant="contained" 
              type="submit" 
              onClick={(event: any) => onComplianceSession(event, planData)}
            >
              <ArrowRightAlt />
              {formatMessage({ id: "law-portal.compliance-law.execute.evaluation-for-all" })}
            </Button>
          )}
        </Grid>
      )}
    </>
  );
});

export const CarryLK = () => {
  const {
    startComplianceSession,
    setLawsSelectedForCompliance,
    toggleCompliance,
    setPlan,
    setPLanEdit
  } = useComplianceState();

  const classes = useStyles();
  const [createvisible, setcreateVisible] = useState(false);
  const { customerId, firstName, lastName, hasAccessToModule, hasAccessToFeature } = useContext(UserContext);
  const { api, abortController } = useAptorApi();
  const [directPlanLoading, setDirectPlanLoading] = useState(false);
  const [planData, setPlanData] = useState<any[]>([]);
  const [directPlan, setDirectPlanData] = useState<any[]>([]);
  const [expendDirectPlanPanel, setExpendDirectPlanPanel] = useState("");
  const [expendPlanPanel, setExpendPlanPanel] = useState("");
  const { formatMessage } = useIntl();
  const { setHeader } = useContext(ModuleContext);
  const [filters, setFilter] = useFilter();
  const [search, setSearch] = useState("");
  const location = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const [allcontrol, setAllControl] = useState<any[]>([]);
  const navigate = useNavigate();
  const [archivePlan, setArchivePlan] = useState<any[]>([]);
  const { deleteConfirmation } = useConfirmation();
  const { enqueueSnackbar } = useSnackbar();
  const [activeTab, setActiveTab] = useState<string>('ongoing-plan');
  const tableRef = React.createRef();
  const [startCompliance, setStartCompliance] = useState(false);
  const [forceRender, setForceRender] = useState(0);

  // Memoize current user name
  const currentuserName = useMemo(() => 
    `${firstName} ${lastName}`, 
    [firstName, lastName]
  );

  // Memoize menu
  const menu = useMemo(() => {
    const baseMenu:any = [];
    if (hasAccessToModule(Module.Administration) || hasAccessToModule(Module.Organization)) {
      baseMenu.push({
        title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.planning.lek' }),
        to: `/law-portal/legal-compliance-control/planning`,
      });
    }
    baseMenu.push(
      {
        title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.carry.lek' }),
        to: `/law-portal/legal-compliance-control/carry`,
      },
      {
        title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.reports.lek' }),
        to: `/law-portal/legal-compliance-control/reports`,
      }
    );
    return baseMenu;
  }, [hasAccessToModule, formatMessage]);

  useEffect(() => {
    setHeader(
      formatMessage({ id: 'law-portal.legal.compliance.header', defaultMessage: 'Legal compliance control' }), 
      menu
    );
  }, [setHeader, formatMessage, menu]);

  useEffect(() => {
    const queryParamsMap = {
      tags: 'tags',
      companyUnit: 'companyUnit',
      complianceUsers: 'complianceUsers',
      processes: 'processes',
      aspects: 'aspects',
      category: 'category',
      area: 'area',
    };
    const searchQuery = queryParams.getAll('search');
    if (searchQuery.length) {
      setSearch(searchQuery[0]);
    }
    Object.entries(queryParamsMap).forEach(([queryKey, stateKey]) => {
      const queryValues = queryParams.getAll(queryKey);
      if (queryValues.length) {
        setFilter(stateKey, queryValues.join(',').split(',').map(num => num.toString()));
      }
    });
  }, []);

  // Memoize confirmation messages
  const archiveconfirmation = useMemo(() => ({
    title: formatMessage({ id: 'component.plan-change.archive.label' }),
    description: formatMessage({ id: 'component.plan-change.archive.confirmation' }),
  }), [formatMessage]);

  const unarchiveconfirmation = useMemo(() => ({
    title: formatMessage({ id: 'component.plan-change.archive.label' }),
    description: formatMessage({ id: 'component.plan-change.unarchive.confirmation' }),
  }), [formatMessage]);

  // Memoized callbacks
  const getplanLaws = useCallback(async (planData: any) => {
    const response: any = await api.getPlanLawsexecute(planData.id);
    if (response?.length === 0 || response == null) {
      enqueueSnackbar(
        formatMessage({ id: 'evelution-all-error-msg' }, { companyunitname: planData?.customerCompanyUnitId?.name }), 
        { variant: 'error' }
      );
    }
    setPlan(planData);
    setLawsSelectedForCompliance(response);
    setStartCompliance(true);
  }, [api, enqueueSnackbar, formatMessage, setPlan, setLawsSelectedForCompliance]);

  const getPlanRequirement = useCallback(async (planData: any) => {
    const response: any = await api.getPlanrequirementexecute(planData.id);
    if (response?.length === 0 || response == null) {
      enqueueSnackbar(
        formatMessage({ id: 'evelution-all-error-msg' }, { companyunitname: planData?.customerCompanyUnitId?.name }), 
        { variant: 'error' }
      );
    }
    setPlan(planData);
    setLawsSelectedForCompliance(response);
    setStartCompliance(true);
  }, [api, enqueueSnackbar, formatMessage, setPlan, setLawsSelectedForCompliance]);

  const handleComplianceSession = useCallback(async (event: any, planData: any) => {
    event.stopPropagation();
    if (planData?.type === 1) {
      await getPlanRequirement(planData);
    } else {
      await getplanLaws(planData);
    }
    setStartCompliance(false);
  }, [getPlanRequirement, getplanLaws]);

  useEffect(() => {
    startComplianceSession();
  }, [startCompliance, startComplianceSession]);

  const handleAllControl = useCallback(async () => {
    const allcompliance: any = await api.getAllcompliancePlanAllControl<any>(customerId, {
      search: search,
      filters: filters
    });

    if (hasAccessToFeature(LawPortalFeature.Statistics, AccessLevel.Read)) {
      setAllControl(allcompliance?.filter((data: any) => data?.isActive === true && data.isArchived !== true));
    } else {
      setAllControl(allcompliance?.filter((val: any) => {
        const responsible = val?.responsibles?.split(',');
        responsible?.forEach((item: any, index: any, array: any) => {
          array[index] = item.toLowerCase();
        });
        return responsible?.includes(currentuserName.toLowerCase()) &&
          val?.isActive === true &&
          val.isArchived !== true;
      }));
    }
  }, [api, customerId, search, filters, hasAccessToFeature, currentuserName]);

  const getComplianceDirectPlan = useCallback(async () => {
    setDirectPlanLoading(true);
    try {
      const response: any = await api.getAllcompliancePlan(customerId, { filters: filters, search: search });
      
      if (!abortController.current.signal.aborted) {
        const sortData = (arr: any[]) => {
          return arr?.sort((a: any, b: any) => {
            const startDateComparison = new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
            if (startDateComparison === 0) {
              return a.name.localeCompare(b.name);
            }
            return startDateComparison;
          }) || [];
        };

        const plan = response?.customerPlans?.filter((val: any) => !val.isDirect && val.isActive && !val.isArchived) || [];
        const directPlanData = response?.customerPlans?.filter((val: any) => val.isDirect && !val.isArchived) || [];
        const archived = response?.customerPlans?.filter((val: any) => val.isArchived) || [];

        setPlanData(sortData(plan));
        setDirectPlanData(sortData(directPlanData));
        setArchivePlan(sortData(archived));
      }
    } catch (error) {
      console.error('Error fetching compliance plans:', error);
    } finally {
      setDirectPlanLoading(false);
    }
  }, [api, customerId, filters, search, abortController]);

  const handleArchive = useCallback((planData: any) => {
    const onReplace = async () => {
      await api.updatePlan(planData?.id, { isArchived: true })
      handleAllControl()
      return getComplianceDirectPlan()
    };

    const onCancel = () => { };

    deleteConfirmation(
      onReplace,
      archiveconfirmation,
      onCancel,
    );
  }, [api, handleAllControl, getComplianceDirectPlan, deleteConfirmation, archiveconfirmation]);

  const handleunArchive = useCallback((planData: any) => {
    const onReplace = async () => {
      await api.updatePlan(planData?.id, { isArchived: false })
      handleAllControl()
      return getComplianceDirectPlan()
    };

    const onCancel = () => { };

    deleteConfirmation(
      onReplace,
      unarchiveconfirmation,
      onCancel,
    );
  }, [api, handleAllControl, getComplianceDirectPlan, deleteConfirmation, unarchiveconfirmation]);

  const handleComplianceSessionnew = useCallback(async (event: any, lawData: any) => {
    let lawDatanew = { planid: lawData.id, ...lawData };
    lawDatanew.id = lawData?.legislationId;
    setStartCompliance(true);
    event.stopPropagation();
    setPlan(lawData);
    await toggleCompliance(lawDatanew);
    setStartCompliance(false);
  }, [setPlan, toggleCompliance]);

  const handleEditSession = useCallback(async (lawData: any) => {
    let lawDatanew = { planid: lawData.id, ...lawData };
    lawDatanew.id = lawData?.legislationId;
    setStartCompliance(true);
    setPlan(lawData);
    setPLanEdit(true);
    await toggleCompliance(lawDatanew);
    setStartCompliance(false);
  }, [setPlan, setPLanEdit, toggleCompliance]);

  const handlemsg = useCallback(() => {
    enqueueSnackbar(formatMessage({ id: 'component.law-error-description' }), {
      variant: 'error',
    });
  }, [enqueueSnackbar, formatMessage]);

  useEffect(() => {
    getComplianceDirectPlan();
  }, [filters, search]);

  useEffect(() => {
    handleAllControl();
  }, [filters, search]);

  useEffect(() => {
    const keysToRemove: string[] = [];
    const itemCount = localStorage.length;
    
    for (let i = 0; i < itemCount; i++) {
      const key = localStorage.key(i);
      if (key) {
        const checkCompliance = key.split(/[_-]/)[0];
        if (checkCompliance === "compliance" || checkCompliance === "ComplianceSession") {
          keysToRemove.push(key);
        }
      }
    }
    
    keysToRemove.forEach(key => localStorage.removeItem(key));
  }, []);

  useEffect(() => {
    setExpendDirectPlanPanel("");
    setExpendPlanPanel("");
  }, [filters, search]);

  useEffect(() => {
    let updatedQueryParams = Object.keys(filters)
      .filter(key => filters[key]?.join() !== undefined && filters[key]?.join() !== "")
      .map(key => `${key}=${encodeURIComponent(filters[key]?.join())}`)
      .join('&');
    if (search !== "") {
      updatedQueryParams = `${updatedQueryParams}&search=${search}`;
    }
    navigate({
      pathname: location.pathname,
      search: `?${updatedQueryParams}`,
    }, { replace: true });
  }, [filters, search, location.pathname, navigate]);

  // Column definitions for ALL PLAN tab
  const allPlanColumns = [
    { 
      title: formatMessage({ id: 'law-portal.our-laws.table.number' }), 
      field: 'number', 
      sorting: false 
    },
    {
      title: formatMessage({ id: 'law-portal.our-laws.table.law' }),
      field: 'legislation',
      sorting: false,
    },
    { 
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.name-of-control' }), 
      field: 'name', 
      sorting: false 
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Company-unit' }),
      field: 'customerCompanyUnitId',
      render: (row: any) => row?.customerCompanyUnitId?.name,
      sorting: false
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Start-date' }),
      field: 'startDate',
      render: (row: any) => moment(row?.startDate).format('YYYY-MM-DD'),
      sorting: false
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.End-date' }), 
      field: 'endDate',
      render: (row: any) => row?.endDate ? moment(row?.endDate).format('YYYY-MM-DD') : "-", 
      sorting: false
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Recuring-interval' }),
      field: 'recurrentInterval',
      render: (row: any) => row?.recurrentInterval || "-",
      sorting: false
    },
    {
      title: formatMessage({ id: 'law-portal.compliance.report.table.col' }),
      field: 'responsibles',
      render: (row: any) => {
        if (row.responsibles) {
          const responsiblearr = row?.responsibles?.split(',');
          return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {responsiblearr?.map((val: any, index: number) => (
                <span key={index}>{val}</span>
              ))}
            </div>
          );
        }
        return "-";
      },
      sorting: false,
      width: "20%"
    },
    {
      title: '',
      field: '',
      render: (row: any) => {
        const responsible = row?.responsibles?.split(',');
        responsible?.forEach((item: any, index: any, array: any) => {
          array[index] = item.toLowerCase();
        });
        return (
          <>
            {responsible?.includes(currentuserName.toLowerCase()) ? (
              row.isStarted ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '7px' }}>
                  <Tooltip title={formatMessage({ id: "law-portal.our-law.compliance.edit" })}>
                    <Edit 
                      style={{ cursor: 'pointer' }} 
                      onClick={() => row?.hasAccessToExecute === 0 ? handlemsg() : handleEditSession(row)} 
                    />
                  </Tooltip>
                </div>
              ) : (
                <Button
                  variant="contained"
                  onClick={(event: any) => row?.hasAccessToExecute === 0 ? handlemsg() : handleComplianceSessionnew(event, row)}
                >
                  {row?.type === 1 
                    ? formatMessage({ id: "law-portal.our-laws.compliance.tab.carryout.kek.create.button" }) 
                    : formatMessage({ id: "law-portal.our-laws.compliance.tab.carryout.create.button" })
                  }
                </Button>
              )
            ) : ""}
          </>
        );
      },
    },
  ];

  // Column definitions for other tabs
  const regularPlanColumns = [
    { 
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.name-of-control' }), 
      field: 'name',
      sorting: false
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Company-unit' }),
      field: 'customerCompanyUnitId',
      render: (row: any) => row?.customerCompanyUnitId?.name,
      sorting: false,
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Start-date' }),
      field: 'startDate',
      render: (row: any) => moment(row?.startDate).format('YYYY-MM-DD'),
      sorting: false,
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.End-date' }), 
      field: 'endDate',
      render: (row: any) => row?.endDate ? moment(row?.endDate).format('YYYY-MM-DD') : "-", 
      sorting: false,
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Recuring-interval' }),
      field: 'recurrentInterval',
      render: (row: any) => row?.recurrentInterval || "-",
      sorting: false,
    },
    {
      title: formatMessage({ id: 'utils.filters.status' }),
      field: 'status',
      render: (row: any) => `${row.executedLawCount} ${formatMessage({ id: 'text.of' })} ${row.lawCount} ${formatMessage({ id: 'status.text' })} `,
      sorting: false,
    },
    {
      title: "",
      field: '',
      render: (row: any) => (
        <IconsNode 
          planData={row} 
          activeTab={activeTab}
          onArchive={handleArchive}
          onUnarchive={handleunArchive}
          onComplianceSession={handleComplianceSession}
          formatMessage={formatMessage}
        />
      ),
      sorting: false,
    },
  ];

  // Determine current columns based on activeTab
  const currentColumns = activeTab === 'all' ? allPlanColumns : regularPlanColumns;

  // Determine current data based on activeTab
  const currentData = 
    activeTab === 'all' ? allcontrol :
    activeTab === 'complete' ? archivePlan :
    activeTab === 'ongoing-plan' ? planData :
    activeTab === 'ongoing-direct' ? directPlan :
    planData;

  // Handler for tab clicks
  const handleTabClick = useCallback((tabName: string) => {
    setActiveTab(tabName);
    setForceRender(prev => prev + 1);
  }, []);

  // Handler for starting compliance from detail panel
  const handleDetailStartCompliance = useCallback((lawData: any, plan: any) => {
    setPlan(plan);
    toggleCompliance(lawData);
    startComplianceSession();
  }, [setPlan, toggleCompliance, startComplianceSession]);

  // Handler for editing compliance from detail panel
  const handleDetailEditCompliance = useCallback((lawData: any, plan: any) => {
    setPlan(plan);
    setPLanEdit(true);
    toggleCompliance(lawData);
    startComplianceSession();
  }, [setPlan, setPLanEdit, toggleCompliance, startComplianceSession]);

  // Detail panel
  const detailPanel = activeTab !== 'all' ? [
    {
      tooltip: formatMessage({ id: "text.expend" }),
      render: (rowData: any) => (
        <PlanningViewLK 
          planData={rowData?.rowData || rowData} 
          filters={filters} 
          search={search}
          activeTab={activeTab}
          onStartCompliance={handleDetailStartCompliance}
          onEditCompliance={handleDetailEditCompliance}
        />
      ),
    }
  ] : undefined;

  // Toolbar component
  const ToolbarComponent = useCallback((props: any) => (
    <div className={classes.toolbar} style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex' }}>
        <div
          className={`${classes.tabsize} ${activeTab === "ongoing-plan" ? classes?.tabActive : classes?.tab}`}
          onClick={() => handleTabClick('ongoing-plan')}
          style={{ cursor: 'pointer' }}
        >
          {formatMessage({ id: 'law-portal.compliance.tab.carryout.heading.continuously' })}
          <span className={classes?.tabNumber}>{planData?.length}</span>
        </div>
        <div
          className={`${classes.tabsize} ${activeTab === "ongoing-direct" ? classes?.tabActive : classes?.tab}`}
          onClick={() => handleTabClick('ongoing-direct')}
          style={{ cursor: 'pointer' }}
        >
          {formatMessage({ id: 'law-portal.compliance.tab.carryout.heading.ongoing' })}
          <span className={classes?.tabNumber}>{directPlan?.length}</span>
        </div>
        <div
          className={`${classes.tabsize} ${activeTab === "all" ? classes?.tabActive : classes?.tab}`}
          onClick={() => handleTabClick('all')}
          style={{ cursor: 'pointer' }}
        >
          {formatMessage({ id: 'law-portal.compliance-law.direct_plan-compliance.all-control' })}
          <span className={classes?.tabNumber}>{allcontrol?.length}</span>
        </div>
        <div
          className={`${classes.tabsize} ${activeTab === "complete" ? classes?.tabActive : classes?.tab}`}
          onClick={() => handleTabClick('complete')}
          style={{ cursor: 'pointer' }}
        >
          {formatMessage({ id: 'lawportal.evalution.completed.compliance.tab' })}
          <span className={classes?.tabNumber}>{archivePlan?.length}</span>
        </div>
      </div>
      <MTableToolbar {...props} />
    </div>
  ), [activeTab, classes, planData, directPlan, allcontrol, archivePlan, formatMessage, handleTabClick]);

  return (
    <div className={classes.listWrapper}>
      {createvisible ? (
        <ButtonLink 
          text={formatMessage({ id: "component.back-button.back" })} 
          to={''} 
          onclick={() => setcreateVisible(false)} 
        />
      ) : (
        <ButtonLink 
          text={formatMessage({ id: "law-portal.legal.complaince.create.new.compliance.direct" })} 
          to={''} 
          onclick={() => setcreateVisible(true)} 
        />
      )}
      <hr style={{ marginTop: '25px', marginBottom: "25px" }} />
      {createvisible ? (
        <CreateDirectCompliance 
          getComplianceDirectPlan={getComplianceDirectPlan} 
          handleAllControl={handleAllControl} 
          setcreateVisible={setcreateVisible} 
        />
      ) : (
        <>
          <ExecuteFilter 
            filters={filters} 
            setFilter={setFilter} 
            search={search} 
            setSearch={(value: any) => setSearch(value)} 
          />
          <hr style={{ marginTop: '25px', marginBottom: "25px" }} />
          <Transition isLoading={directPlanLoading}>
            <MTable
              key={`${activeTab}-${forceRender}`}
              tableRef={tableRef}
              columns={currentColumns}
              data={currentData}
              options={{
                detailPanelColumnAlignment: 'right',
                pageSizeOptions: [5, 10, 20, 50, 100],
                debounceInterval: 500,
              }}
              components={{
                Toolbar: ToolbarComponent
              }}
              detailPanel={detailPanel}
            />
          </Transition>
        </>
      )}
    </div>
  );
};